import React, { useState } from "react";
import { Button, Input, Modal, Form } from "antd";
import { useSelector, useDispatch } from "react-redux";
import "./QuotesApprovedPopup.css";

const QuotesApprovedPopup = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [taskType, setTaskType] = useState(null);

  return (
    <div id="">
      <Modal
        {...props}
        // title={"props.title"}
        centered
        open={props.open}
        onOk={() => props.onOk()}
        onCancel={() => props.onCancel()}
        closable={true}
        loading={false}
        width={{
          xs: "90%",
          sm: "80%",
          md: "70%",
          lg: "60%",
          xl: "40%",
          xxl: "35%",
        }}
        classNames={{
          footer: "",
        }}
        footer={null}
        className="quotes-approved-modal"
      >
        <div className="flex items-center gap-6">
          <p className="createTasks">Create Tasks</p>

          <div className="p-4 d-flex flex-column">
            <p style={{ fontSize: "16px", fontWeight: 600 }}>
              How would you like to create tasks for this quotation?
            </p>

            <label className="pt-2 d-flex gap-2 pointer">
              <input
                type="radio"
                name="quotes"
                value="male"
                style={{ width: "18px", height: "18px", marginTop: "5px" }}
              />
              <p
                className="mb-0"
                style={{ fontSize: "16px", fontWeight: 600 }}
                onClick={() => {
                  props.onTaskTypeChange(true);
                  setTaskType(true);
                }}
              >
                Task per line
                <br />
                <span className="qtsublines">
                  Create a separate task for each quotation line item.
                </span>
              </p>
            </label>

            <label className="d-flex gap-2 pointer mt-3">
              <input
                type="radio"
                name="quotes"
                value="male"
                className=""
                style={{ width: "18px", height: "18px", marginTop: "5px" }}
              />
              <p
                className="mb-0"
                style={{ fontSize: "16px", fontWeight: 600 }}
                onClick={() => {
                  props.onTaskTypeChange(false);
                  setTaskType(false);
                }}
              >
                Single task
                <br />
                <span className="qtsublines">
                  Create one task containing all quotation line items.
                </span>
              </p>
            </label>

            <Button
              key="submit"
              // loading={props.loading}
              loading={loading}
              disabled={taskType === null}
              className="approvedbtn mt-4 m-auto p-4"
              onClick={() => {
                props.onOk();
                // handleSubmit();
              }}
            >
              Approved
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default QuotesApprovedPopup;
